import { Image } from 'antd';
import { type FC, type ReactNode, useState } from 'react';

type IProps = {
  src?: string;
  children?: ReactNode;
};

const Preview: FC<IProps> = ({ src, children }) => {
  const [visible, setVisible] = useState(false);

  return (
    <>
      <span className="cursor-pointer" onClick={() => setVisible(true)}>
        {children}
      </span>
      <Image
        style={{ display: 'none' }}
        preview={{
          visible,
          src,
          onVisibleChange: (value) => {
            setVisible(value);
          },
        }}
      />
    </>
  );
};

export default Preview;
